import level001 from './Level 001.json';
import level002 from './Level 002.json';
import level003 from './Level 003.json';
import level004 from './Level 004.json';
import level005 from './Level 005.json';
import level006 from './Level 006 Ad and Coin.json';
import level007 from './Level 007.json';
import level008 from './Level 008 Ad and Coin.json';
import level009 from './Level 009 Ad and Coin.json';
import level010 from './Level 010 Ad and Coin.json';
import level011 from './Level 011 Ad and Coin.json';
import level012 from './Level 012 Ad and Coin.json';
import level013 from './Level 013 Ad and Coin.json';
import level014 from './Level 014 Ad and Coin.json';
import level015 from './Level 015 Ad and Coin.json';
import level016 from './Level 016 Ad and Coin.json';
import level017 from './Level 017 Ad and Coin.json';
import level018 from './Level 018 Ad and Coin.json';
import level019 from './Level 019 Ad and Coin.json';
import level020 from './Level 020 Ad and Coin.json';
import level021 from './Level 021.json';
import level022 from './Level 022 Ads and Coins.json';
import level023 from './Level 023 Ads and Coins.json';
import level024 from './Level 024 Ads and Coins.json';
import level025 from './Level 025.json';
import level026 from './Level 026 Ads and Coins.json';
import level027 from './Level 027 Ads and Coins.json';
import level028 from './Level 028.json';
import level029 from './Level 029 Ads and Coins.json';
import level030 from './Level 030 Ads and Coins.json';
import level031 from './Level 031.json';
import level032 from './Level 032 Ads and Coins.json';
import level033 from './Level 033 Ads and Coins.json';
import level034 from './Level 034 Ads and Coins.json';
import level035 from './Level 035 Ads and Coins.json';
import level036 from './Level 036 Ads and Coins.json';
import level037 from './Level 037 Ads and Coins.json';
import level038 from './Level 038 Ads and Coins.json';
import level039 from './Level 039 Ads and Coins.json';
import level040 from './Level 040 Ads and Coins.json';
import level041 from './Level 041.json';
import level042 from './Level 042 Ads and Coins.json';
import level043 from './Level 043 Ads and Coins.json';
import level044 from './Level 044 Ads and Coins.json';
import level045 from './Level 045 Ads and Coins.json';
import level046 from './Level 046 Ads and Coins.json';
import level047 from './Level 047 Ads and Coins.json';
import level048 from './Level 048 Ads and Coins.json';
import level049 from './Level 049 Ads and Coins.json';
import level050 from './Level 050 Ads and Coins.json';
import level051 from './Level 051.json';
import level052 from './Level 052 Ads and Coins.json';
import level053 from './Level 053 Ads and Coins.json';
import level054 from './Level 054 Ads and Coins.json';
import level055 from './Level 055 Ads and Coins.json';
import level056 from './Level 056 Ads and Coins.json';
import level057 from './Level 057 Ads and Coins.json';
import level058 from './Level 058 Ads and Coins.json';
import level059 from './Level 059 Ads and Coins.json';
import level060 from './Level 060 Ads and Coins.json';
import level061 from './Level 061 Ads and Coins.json';
import level062 from './Level 062 Ads and Coins.json';
import level063 from './Level 063 Ads and Coins.json';
import level064 from './Level 064 Ads and Coins.json';
import level065 from './Level 065 Ads and Coins.json';
import level066 from './Level 066 Ads and Coins.json';
import level067 from './Level 067 Ads and Coins.json';
import level068 from './Level 068 Ads and Coins.json';
import level069 from './Level 069 Ads and Coins.json';
import level070 from './Level 070 Ads and Coins.json';
import level071 from './Level 071.json';
import level072 from './Level 072 Ads and Coins.json';
import level073 from './Level 073 Ads and Coins.json';
import level074 from './Level 074 Ads and Coins.json';
import level075 from './Level 075 Ads and Coins.json';
import level076 from './Level 076 Ads and Coins.json';
import level077 from './Level 077 Ads and Coins.json';
import level078 from './Level 078 Ads and Coins.json';
import level079 from './Level 079 Ads and Coins.json';
import level080 from './Level 080 Ads and Coins.json';
import level081 from './Level 081 Ads and Coins.json';
import level082 from './Level 082 Ads and Coins.json';
import level083 from './Level 083 Ads and Coins.json';
import level084 from './Level 084 Ads and Coins.json';
import level085 from './Level 085 Ads and Coins.json';
import level086 from './Level 086 Ads and Coins.json';
import level087 from './Level 087 Ads and Coins.json';
import level088 from './Level 088 Ads and Coins.json';
import level089 from './Level 089 Ads and Coins.json';
import level090 from './Level 090 Ads and Coins.json';
import level091 from './Level 091.json';
import level092 from './Level 092 Ads and Coins.json';
import level093 from './Level 093 Ads and Coins.json';
import level094 from './Level 094 Ads and Coins.json';
import level095 from './Level 095 Ads and Coins.json';
import level096 from './Level 096 Ads and Coins.json';
import level097 from './Level 097 Ads and Coins.json';
import level098 from './Level 098 Ads and Coins.json';
import level099 from './Level 099 Ads and Coins.json';
import level100 from './Level 100 Ads and Coins.json';
import level101 from './Level 101 Ads and Coins.json';
import level102 from './Level 102 Ads and Coins.json';
import level103 from './Level 103 Ads and Coins.json';
import level104 from './Level 104 Ads and Coins.json';
import level105 from './Level 105 Ads and Coins.json';
import level106 from './Level 106 Ads and Coins.json';
import level107 from './Level 107 Ads and Coins.json';
import level108 from './Level 108 Ads and Coins.json';
import level109 from './Level 109 Ads and Coins.json';
import level110 from './Level 110 Ads and Coins.json';
import type { LevelData } from '../../../src/game/level/LevelData';

export const adCoinRawLevels: Partial<LevelData>[] = [
  level001 as unknown as LevelData,
  level002 as unknown as LevelData,
  level003 as unknown as LevelData,
  level004 as unknown as LevelData,
  level005 as unknown as LevelData,
  level006 as unknown as LevelData,
  level007 as unknown as LevelData,
  level008 as unknown as LevelData,
  level009 as unknown as LevelData,
  level010 as unknown as LevelData,
  level011 as unknown as LevelData,
  level012 as unknown as LevelData,
  level013 as unknown as LevelData,
  level014 as unknown as LevelData,
  level015 as unknown as LevelData,
  level016 as unknown as LevelData,
  level017 as unknown as LevelData,
  level018 as unknown as LevelData,
  level019 as unknown as LevelData,
  level020 as unknown as LevelData,
  level021 as unknown as LevelData,
  level022 as unknown as LevelData,
  level023 as unknown as LevelData,
  level024 as unknown as LevelData,
  level025 as unknown as LevelData,
  level026 as unknown as LevelData,
  level027 as unknown as LevelData,
  level028 as unknown as LevelData,
  level029 as unknown as LevelData,
  level030 as unknown as LevelData,
  level031 as unknown as LevelData,
  level032 as unknown as LevelData,
  level033 as unknown as LevelData,
  level034 as unknown as LevelData,
  level035 as unknown as LevelData,
  level036 as unknown as LevelData,
  level037 as unknown as LevelData,
  level038 as unknown as LevelData,
  level039 as unknown as LevelData,
  level040 as unknown as LevelData,
  level041 as unknown as LevelData,
  level042 as unknown as LevelData,
  level043 as unknown as LevelData,
  level044 as unknown as LevelData,
  level045 as unknown as LevelData,
  level046 as unknown as LevelData,
  level047 as unknown as LevelData,
  level048 as unknown as LevelData,
  level049 as unknown as LevelData,
  level050 as unknown as LevelData,
  level051 as unknown as LevelData,
  level052 as unknown as LevelData,
  level053 as unknown as LevelData,
  level054 as unknown as LevelData,
  level055 as unknown as LevelData,
  level056 as unknown as LevelData,
  level057 as unknown as LevelData,
  level058 as unknown as LevelData,
  level059 as unknown as LevelData,
  level060 as unknown as LevelData,
  level061 as unknown as LevelData,
  level062 as unknown as LevelData,
  level063 as unknown as LevelData,
  level064 as unknown as LevelData,
  level065 as unknown as LevelData,
  level066 as unknown as LevelData,
  level067 as unknown as LevelData,
  level068 as unknown as LevelData,
  level069 as unknown as LevelData,
  level070 as unknown as LevelData,
  level071 as unknown as LevelData,
  level072 as unknown as LevelData,
  level073 as unknown as LevelData,
  level074 as unknown as LevelData,
  level075 as unknown as LevelData,
  level076 as unknown as LevelData,
  level077 as unknown as LevelData,
  level078 as unknown as LevelData,
  level079 as unknown as LevelData,
  level080 as unknown as LevelData,
  level081 as unknown as LevelData,
  level082 as unknown as LevelData,
  level083 as unknown as LevelData,
  level084 as unknown as LevelData,
  level085 as unknown as LevelData,
  level086 as unknown as LevelData,
  level087 as unknown as LevelData,
  level088 as unknown as LevelData,
  level089 as unknown as LevelData,
  level090 as unknown as LevelData,
  level091 as unknown as LevelData,
  level092 as unknown as LevelData,
  level093 as unknown as LevelData,
  level094 as unknown as LevelData,
  level095 as unknown as LevelData,
  level096 as unknown as LevelData,
  level097 as unknown as LevelData,
  level098 as unknown as LevelData,
  level099 as unknown as LevelData,
  level100 as unknown as LevelData,
  level101 as unknown as LevelData,
  level102 as unknown as LevelData,
  level103 as unknown as LevelData,
  level104 as unknown as LevelData,
  level105 as unknown as LevelData,
  level106 as unknown as LevelData,
  level107 as unknown as LevelData,
  level108 as unknown as LevelData,
  level109 as unknown as LevelData,
  level110 as unknown as LevelData,
];
